export enum NavigationTabEnum {
  PROFILE = 'profile',
  EXPLORE = 'explore',
  ORG_CHART = 'orgChart',
  HOME = 'home',
  NOTIFICATIONS = 'notifications',
  ADMIN = 'admin',
  FEEDBACK = 'feedback',
}
